import { render } from "./invoice.vue?vue&type=template&id=3c955ae8&scoped=true"
import script from "./invoice.vue?vue&type=script&lang=js"
export * from "./invoice.vue?vue&type=script&lang=js"

import "./invoice.vue?vue&type=style&index=0&id=3c955ae8&lang=scss&scoped=true"
import "./invoice.vue?vue&type=style&index=1&id=3c955ae8&lang=scss"

import exportComponent from "/Users/a/Desktop/app/boyuan_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c955ae8"]])

export default __exports__